import { render, staticRenderFns } from "./CategoryUsers.vue?vue&type=template&id=db9ca588"
import script from "./CategoryUsers.vue?vue&type=script&lang=js"
export * from "./CategoryUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports